import api from './api';

export interface UserSettings {
  _id: string;
  userId: string;
  ridePreferences: {
    autoAcceptRides: boolean;
    workingHours: {
      start: string;
      end: string;
    };
    workingHoursEnabled: boolean;
    serviceAreas: Array<{
      name: string;
      coordinates: {
        lat: number;
        lng: number;
      };
      radius: number;
    }>;
    currentLocation: {
      address: string;
      coordinates: {
        lat: number;
        lng: number;
      };
    };
    locationPreferences: string[];
    defaultRadius: number;
    autoAcceptMatching: boolean;
  };
  whatsappSettings: {
    defaultAccount?: string;
    messageHandling: {
      autoReply: boolean;
      autoReplyMessage: string;
      forwardToEmail: boolean;
      emailAddress?: string;
    };
  };
  notifications: {
    enabled: boolean;
    periods: Array<{
      start: string;
      end: string;
      enabled: boolean;
    }>;
    emailNotifications: boolean;
    pushNotifications: boolean;
    soundEnabled: boolean;
    rideAlerts: {
      newRide: boolean;
      rideUpdate: boolean;
      rideCompletion: boolean;
    };
  };
  ai: {
    enabled: boolean;
    openAIFallbackEnabled: boolean;
    pausedAt?: Date;
    pausedBy?: string;
  };
  dashboard: {
    layout: 'grid' | 'list' | 'compact';
    widgets: Array<{
      type: string;
      position: number;
      visible: boolean;
    }>;
    refreshInterval: number;
  };
  theme: {
    mode: 'light' | 'dark' | 'auto';
    primaryColor: string;
  };
  createdAt: Date;
  updatedAt: Date;
}

export const settingsService = {
  // Get all user settings
  async getSettings(): Promise<UserSettings> {
    const response = await api.get('/settings');
    return response.data;
  },

  // Update all settings
  async updateSettings(settings: Partial<UserSettings>): Promise<UserSettings> {
    const response = await api.put('/settings', settings);
    return response.data;
  },

  // Update specific setting category
  async updateSettingsCategory(category: string, data: any): Promise<UserSettings> {
    const response = await api.put(`/settings/${category}`, data);
    return response.data;
  },

  // Get specific setting category
  async getSettingsCategory(category: string): Promise<any> {
    const response = await api.get(`/settings/${category}`);
    return response.data;
  },

  // Reset settings to defaults
  async resetSettings(): Promise<{ message: string; settings: UserSettings }> {
    const response = await api.post('/settings/reset');
    return response.data;
  }
};

export default settingsService;
